export const normalizePermissions = (rawPerms) =>
  (rawPerms || [])
    .map((p) => {
      if (p && typeof p === "object") {
        if (p.id) return { id: p.id };
        if (p.action && p.subject) {
          return {
            id: `${String(p.action).toLowerCase()}:${String(p.subject).toLowerCase()}`,
          };
        }
      }
      if (typeof p === "string") return { id: p };
      return null;
    })
    .filter(Boolean);

export const syncUserPermissionsToStorage = (user) => {
  if (!user) return [];
  const normalized = normalizePermissions(user?.role?.permissions);
  localStorage.setItem("userInfo", JSON.stringify(user));
  if (normalized.length) {
    localStorage.setItem("permissions", JSON.stringify(normalized));
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("siraj-userinfo"));
  }
  return normalized;
};
